export default __webpack_public_path__ + "static/media/392.40e6fdbc.png";